<template>
    <footer class="footer">
        <div class="container-fluid d-flex flex-wrap justify-content-between align-items-center">
            <nav>
                <ul class="footer-menu">
                    <li>
                        <a href="#" @click.prevent="showHotkeyDiscoveryModal">
                            <i class="fa fa-keyboard"></i>
                            Keyboard Shortcuts
                        </a>
                    </li>
                </ul>
            </nav>
            <div class="copyright text-right">
                &copy; {{ year }}, CP Hub LLC. <br />
                <small>{{ this.environment }} {{ this.version }}</small>
            </div>
        </div>

        <HotkeyDiscoveryModal ref="hotkeyDiscoveryModal" modal-id="hotkey-discovery-modal" />
    </footer>
</template>
<script lang="ts">
import { Component, Watch, Vue } from 'vue-property-decorator';
import HotkeyDiscoveryModal from '@/components/Modals/HotkeyDiscoveryModal.vue';

@Component({
    components: {
        HotkeyDiscoveryModal
    }
})
export default class ContentFooter extends Vue {
    get year() { return new Date().getFullYear(); }
    private environment: string | null = null;
    private version: string | null = null;

    created() {
        document.addEventListener("keyup", this.hotKeyListener);
    }

    @Watch("$root.$data.dataHubFileVersion")
    onDataHubChange() {
        this.environment = this.$root.$data.dataHubFileVersion.environment;
        this.version = this.$root.$data.dataHubFileVersion.version;
    }

    hotKeyListener(e: any) {
        if (e.key === '?' || (e.shiftKey && e.key === '/')) {
            if (e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLInputElement) return;

            e.preventDefault();
            this.showHotkeyDiscoveryModal();
        }
    }

    showHotkeyDiscoveryModal() {
        const modal = this.$refs.hotkeyDiscoveryModal as HotkeyDiscoveryModal;
        modal?.show();
    }
};
</script>
